"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var get = require('lodash/get');

var set = require('lodash/set');

var snakeCase = require('lodash/snakeCase');

var startCase = require('lodash/startCase');

var PaperComponent = require('../../products/interfaces/PaperComponent');

var Envelope = require('../../products/interfaces/Envelope');

var getComposables = require('../PrintingDetails/componentComposables');

var isLetterpressComponent = require('./isLetterpressComponent');

var Inventory = require('./Inventory');

function inventoryPaperComponents(comps, date, options, printerName) {
  var components = comps.filter(function (comp) {
    return Object.prototype.isPrototypeOf.call(PaperComponent.prototype, comp) && !Object.prototype.isPrototypeOf.call(Envelope.prototype, comp);
  });
  var inventory = {};
  var lp_inventory = {};
  components.forEach(function (component) {
    var component_type = component.type;
    var componentSettings = options.printers[printerName].components;
    var component_options = componentSettings[component_type] || componentSettings["default"];
    var paper = component.paper;
    var weight = component.weight === 'n/a' ? '' : component.weight;
    var quantity = component.quantity;
    var field = 'copies';
    var copies = getComposables(field, component_options[field]).reduce(function (accumulator, fn) {
      return fn(accumulator, {}, {}, component, component_options, options);
    }, 0);

    if (quantity && !copies) {
      console.log();
      console.error("Saw quantity but no copies for ".concat(component_type));
      console.log();
      console.log(component);
      console.log();
    }

    var sanitizedPaperType = startCase(paper.toLowerCase()).trim();
    var paperKey = [sanitizedPaperType, weight].join(' ').trim();

    if (isLetterpressComponent(component)) {
      if (get(lp_inventory, [paperKey])) {
        set(lp_inventory, [paperKey], get(lp_inventory, [paperKey]) + copies);
      } else {
        set(lp_inventory, [paperKey], copies);
      }
    } else if (get(inventory, [paperKey])) {
      set(inventory, [paperKey], get(inventory, [paperKey]) + copies);
    } else {
      set(inventory, [paperKey], copies);
    }
  });
  var digital = Object.keys(inventory).map(function (name) {
    return new Inventory({
      name: name,
      date: date,
      unit: 'sheet',
      category: 'paper',
      quantity: inventory[name],
      key: snakeCase(name)
    });
  });
  var letterpress = Object.keys(lp_inventory).map(function (name) {
    return new Inventory({
      name: name,
      date: date,
      unit: 'each',
      category: 'letterpress_paper',
      quantity: lp_inventory[name],
      key: snakeCase(name)
    });
  });
  return [].concat(_toConsumableArray(digital), _toConsumableArray(letterpress));
}

module.exports = inventoryPaperComponents;